import { render, staticRenderFns } from "./CreateCoffeeSpecies.vue?vue&type=template&id=549b0daf"
import script from "./CreateCoffeeSpecies.vue?vue&type=script&lang=js"
export * from "./CreateCoffeeSpecies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports